import {ANSWER_TYPE} from '@common/consts/survey';

export const STOP_LIST_CHANGE = 'STOP_LIST_CHANGE';
export const LIST_CHANGE = 'LIST_CHANGE';

export const MOVE_UP_QUESTION = 'MOVE_UP_QUESTION';
export const MOVE_DOWN_QUESTION = 'MOVE_DOWN_QUESTION';
export const MOVE_UP_SUB_QUESTION = 'MOVE_UP_SUB_QUESTION';
export const MOVE_DOWN_SUB_QUESTION = 'MOVE_DOWN_SUB_QUESTION';

export const mutations = {
    setStopListChange(state, newValue) {
        state.options.stopListChange = newValue;
    },

    moveUpQuestion(state, index) {
        if (index === 0) {
            return;
        }

        if (state.form.questions[index - 1].type === ANSWER_TYPE.PARENT_COUNSEL_WEEK) {
            return;
        }

        state.form.questions = swapQuestion(state.form.questions, index, index - 1);
    },

    moveDownQuestion(state, index) {
        if (index === state.form.questions.length - 1) {
            return;
        }

        state.form.questions = swapQuestion(state.form.questions, index, index + 1);
    },

    moveUpSubQuestion(state, {parentQuestionNo, subQuestionNo}) {
        const parentQuestion = state.form.questions.find(({questionNo}) => questionNo === parentQuestionNo);
        const isTable = parentQuestion.type === ANSWER_TYPE.TABLE;
        const subQuestions = isTable ? parentQuestion.tableQuestions : parentQuestion.questions;
        const targetSubQuestionIndex = subQuestions.findIndex(({questionNo}) => questionNo === subQuestionNo);

        if (targetSubQuestionIndex < 1) {
            return;
        }

        const swappedSubQuestions = swapQuestion(subQuestions, targetSubQuestionIndex, targetSubQuestionIndex - 1);
        if (isTable) {
            parentQuestion.tableQuestions = swappedSubQuestions;
            return;
        }
        parentQuestion.questions = swappedSubQuestions;
    },

    moveDownSubQuestion(state, {parentQuestionNo, subQuestionNo}) {
        const parentQuestion = state.form.questions.find(({questionNo}) => questionNo === parentQuestionNo);
        const isTable = parentQuestion.type === ANSWER_TYPE.TABLE;
        const subQuestions = isTable ? parentQuestion.tableQuestions : parentQuestion.questions;
        const targetSubQuestionIndex = subQuestions.findIndex(({questionNo}) => questionNo === subQuestionNo);

        if (targetSubQuestionIndex === subQuestions.length - 1) {
            return;
        }

        const swappedSubQuestions = swapQuestion(subQuestions, targetSubQuestionIndex, targetSubQuestionIndex + 1);
        if (isTable) {
            parentQuestion.tableQuestions = swappedSubQuestions;
            return;
        }
        parentQuestion.questions = swappedSubQuestions;
    },
};

export const actions = {
    [STOP_LIST_CHANGE]({commit}) {
        commit('setStopListChange', true);
    },

    [LIST_CHANGE]({commit}) {
        commit('setStopListChange', false);
    },

    [MOVE_UP_QUESTION]({commit, state}, index) {
        if (state.form.questions[index - 1].type === ANSWER_TYPE.PARENT_COUNSEL_WEEK) {
            return false;
        }

        commit('moveUpQuestion', index);
        return true;
    },

    [MOVE_DOWN_QUESTION]({commit}, index) {
        commit('moveDownQuestion', index);
    },

    [MOVE_UP_SUB_QUESTION]({commit, state}, {parentQuestionNo, subQuestionNo}) {
        commit('moveUpSubQuestion', {parentQuestionNo, subQuestionNo});
    },

    [MOVE_DOWN_SUB_QUESTION]({commit, state}, {parentQuestionNo, subQuestionNo}) {
        commit('moveDownSubQuestion', {parentQuestionNo, subQuestionNo});
    },
};

/**
 * 두 질문의 위치를 변경한다.
 *
 * @param {QuestionInfoForm[]} questions
 * @param {number} index1
 * @param {number} index2
 * @returns {QuestionInfoForm[]}
 */
function swapQuestion(questions, index1, index2) {
    const newQuestions = questions.slice();
    newQuestions[index1] = questions[index2];
    newQuestions[index2] = questions[index1];
    return newQuestions;
}
